<template>
    <div>
        <Spinner v-if="loading" />
        <Alert v-else-if="error" color="warning" icon="exclamation-circle">{{ error }}</Alert>
        <div v-else class="list-group">
            <div
                v-for="(typeSelector, index) in allTypes"
                :key="typeSelector.id"
                class="list-group-item"
                :class="{ 'bg-light': index % 2 === 0 }"
            >
                <div class="d-flex align-items-center justify-content-between">
                    <Checkbox v-model="selectedTypes" :modelValue="typeSelector.id" @input="emit">{{
                        typeSelector.name[$store.state.lang.displayLanguage]
                    }}</Checkbox>
                    <ButtonCollapse
                        v-if="hasChildren(typeSelector)"
                        :showAll="showAll"
                        :target="`type-${typeSelector.id}`"
                    />
                </div>
                <div
                    v-if="hasChildren(typeSelector)"
                    :id="`type-${typeSelector.id}`"
                    class="collapse ps-5"
                    :class="{ show: showAll }"
                >
                    <div v-for="children in typeSelector.children" :key="children.id" class="type-children pb-1">
                        <Checkbox v-model="selectedTypes" :modelValue="children.id" @input="emit" small>
                            <span class="cursor-pointer">{{ children.name[$store.state.lang.displayLanguage] }}</span>
                        </Checkbox>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="saveButton" class="mt-3">
            <Button icon="check" color="success" @click="save">Save</Button>
        </div>
    </div>
</template>

<script>
    import { Checkbox, Button, Spinner, Alert } from '@tech_hexeko/design-system'
    import ButtonCollapse from '@/components/ButtonCollapse'
    let _ = require('lodash')

    export default {
        components: {
            Checkbox,
            Button,
            ButtonCollapse,
            Spinner,
            Alert,
        },
        props: {
            depth: {
                type: Number,
                default: 1,
            },
            saveButton: {
                type: Boolean,
                default: true,
            },
            showAll: {
                type: Boolean,
                default: false,
            },
            types: Array,
        },
        data() {
            return {
                loading: true,
                allTypes: [],
                selectedTypes: [],
                error: null,
            }
        },
        methods: {
            emit() {
                this.$emit('input', this.selectedTypes)
            },
            fetchData() {
                this.loading = true
                this.$api.types
                    .get({ per_page: 100, depth: this.depth })
                    .then((types) => {
                        this.allTypes = types.data
                        this.error = null
                    })
                    .catch((error) => {
                        this.error = error.response.data.message
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            hasChildren(typeSelector) {
                return Boolean(typeSelector.children && typeSelector.children.length > 0)
            },
            save() {
                this.$emit('save', this.selectedTypes)
            },
        },
        mounted() {
            this.fetchData()
        },
        watch: {
            types: {
                deep: true,
                immediate: true,
                handler(val) {
                    if (val) this.selectedTypes = _.map(this.types, 'id')
                },
            },
        },
    }
</script>

<style type="text/css" scoped>
    .type-children:first-child {
        padding-top: 0.75rem;
    }
</style>
